import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getItems } from "../../../../store/actions/Store/selectedStore";
import { FaPlus } from "react-icons/fa";
import { DotLoader } from "react-spinners";
import { getStoreItems } from "../../../../store/services/Store";
import { showToast } from "../../../../utils/showToast";
import { useNavigate } from "react-router-dom";
import { setItem, setItems } from "../../../../store/actions/Store/item";
import {
  addItemToList,
  addList,
  handleListRequest,
} from "../../../../store/services/Store/List";
import moment from "moment";
import useScroll from "helpers/useScroll";

export const Items = () => {
  const [loading, setLoading] = useState(true);
  const [itemQuery, setItemQuery] = useState("");
  const [listItems, setListItems] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, profile } = useSelector((store) => store.userReducer);
  const { selectedStore, items } = useSelector((store) => store.selectedStore);
  let { activeList } = useSelector((store) => store.storeLists);
  const [isScrollingUp] = useScroll();
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (selectedStore) {
      const fetchData = async () => {
        try {
          setLoading(true);
          const result = await getStoreItems({
            store_id: selectedStore.id,
            item: itemQuery,
          });
          if (result.success) {
            dispatch(getItems(result.data.items));
            setLoading(false);

            if (user) {
              const store_id = selectedStore.id;
              const addedItems = await handleListRequest({
                method: "get",
                url: `users/${user.data.id}/store/${store_id}/lists/${activeList.list_id}`,
                token: user.accessToken,
              });
              if (addedItems.success) {
                let { items } = addedItems.data;
                setListItems(items);
                dispatch(setItems(items));
              }
            } else {
              dispatch(getItems(result.data.items));
              setLoading(false);
            }
          }
        } catch (error) {
          setLoading(false);
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
  }, [selectedStore, itemQuery, dispatch, user, activeList]);
  let createList = null;

  

  const addToList = async (item, changeButtonColor, isAdded, sideItems = []) => {
    console.log('Add to list ran with id ',item)
    let listId = activeList?.list_id;
    if (!user) {
      showToast(
        `To add items to your cart, please log in to ${
          selectedStore?.isWhiteLabel ? selectedStore?.name : "Mavencery"
        } or create an account if you're new.`,
        "error",
        true,
        "OK"
      );
      return;
    }
    if (!activeList) {
      const timeStamp = moment().unix();
      const listName = timeStamp + profile.profile.first_name;
      createList = await addList(user.accessToken, user.data.id, {
        list_name: listName,
        store_id: selectedStore.id,
      });
      if (createList.success) {
        listId = createList.data.id;
        const result = await addItemToList(
          user.accessToken,
          user.data.id,
          listId,
          item.EAN13,
          {
            store_id: selectedStore.id,
          }
        );
        if (result.success) {
          showToast(
            "Default list created and item added to it.",
            "success",
            true
          );
          navigate(`/stores/${selectedStore.id}/dashboard`);
        } else {
          showToast(
            "Something went wrong while adding item to the list",
            "error",
            false
          );
        }
      } else {
        showToast(
          "Something went wrong while creating the list",
          "error",
          false
        );
      }
    }
    if (!item.availability) {
      showToast("Item is currently unavailable", "error", false, "Close");
      return;
    }
    if (isAdded) {
      showToast("Item already added to the list", "error", true);
      return;
    }
    const addedItem = listItems?.find((fI) => fI.EAN13 === item.EAN13);
    if (addedItem) {
      showToast("Item already added to the list.", "error", true);
      return;
    }
    if (activeList.lock) {
      showToast(
        "Can not add/update items in a locked list, kindly unlock to proceed",
        "error",
        false
      );
      return;
    } else {
      const result = await addItemToList(
        user.accessToken,
        user.data.id,
        listId,
        item.EAN13,
        {
          store_id: selectedStore.id,
        }
      );
      if (result.success) {
        dispatch(setItems(item));
        if (item.is_offer_available) {
          let offerNum = parseInt(item.offer_type);
          showToast(
            `Item added successfully in the list. You can avail the offer by adding just ${(
              offerNum - 1
            ).toFixed(1)} more quantity.`,
            "success",
            false,
            "OK"
          );
        } else {
          showToast(result.data, "success", true, "OK");
        }
        changeButtonColor(true);
      } else {
        console.error("error:", result);
      }
    }
  };

  return (
    <div className="flex flex-col  flex-grow w-[100%] mx-auto ">
      <div
        className={`w-full z-19 transition-all duration-300 ${
          isSticky
            ? "fixed top-0 left-1/2 lg:w-[40%] md:w-[50%] -translate-x-1/2 animate-slideDown"
            : "absolute top-16 left-1/2 -translate-x-1/2 md:w-[50%] lg:w-2/5"
        }
        ${
          isScrollingUp
            ? "fixed top-16 left-1/2 -translate-x-1/2 md:w-[50%] lg:w-2/5"
            : ""
        }`}
      >
        <div
          style={{
            boxShadow: "0px 0px 6px 0px #CDCACA",
          }}
          className="mt-1 overflow-hidden bg-white rounded-md "
        >
          <div className="flex flex-wrap items-stretch w-full">
            <input
              onChange={(e) => setItemQuery(e.target.value)}
              type="search"
              className="m-0 block flex-auto rounded border border-solid border-neutral-600 bg-white bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-neutral-700 outline-none transition duration-200 ease-in-out focus:z-[3] focus:border-theme-color focus:text-neutral-700 focus:shadow-[inset_0_0_0_1px_rgb(59,113,202)] focus:outline-none"
              placeholder="Search"
            />
          </div>
        </div>
      </div>
      {loading ? (
        <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full ">
          <div className="relative">
            <DotLoader
              color={selectedStore?.theme.color}
              speedMultiplier={2}
              size={50}
            />
          </div>
        </div>
      ) : (
        <div className={isSticky ? "mt-16" : ""}>
          {items.length === 0 ? (
            <div className="min-h-screen">
              <p className="mt-32 text-center text-red-500">No items found</p>
            </div>
          ) : (
            <div className="  4xl:w-[96%]  py-8 lg:ml-[64px] lg:mr-[64px]   ">
              <ItemGrid
                selectedStore={selectedStore}
                user={user}
                items={items}
                addToList={addToList}
                listItems={listItems}
                activeList={activeList}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const ItemCard = ({ selectedStore, user, item, addToList, listItems }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isAdded, setIsAdded] = useState(false);
  const addedItem = listItems?.find((fI) => fI.EAN13 === item.EAN13);
  let changeButtonColor = (value) => {
    setIsAdded(value);
  };
  // Ensure price is a number before calling toFixed
  const priceNumber = parseFloat(item?.price);
  const displayPrice = isNaN(priceNumber) ? "0.00" : priceNumber.toFixed(2);
  const itemHandler = (item) => {
    if (user) {
      if (!item.availability) return;
      dispatch(setItem(item));
      navigate(`/stores/${selectedStore.id}/items/${item.itemId}/itemRetail`);
    }
  };
  return (
    <div
      style={{
        boxShadow: "0px 0px 6px 0px #CDCACA",
      }}
      className="w-2/3 4xl:my-4 4xl:mx-0 h-auto bg-white border-gray-200 rounded md:h-auto lg:h-auto md:w-full  lg:w-full 4xl:w-[85%] hover:shadow-2xl hover:border"
    >
      <div className="px-6 py-4">
        <div className="flex items-center justify-between mb-1">
          <p
            style={{
              color: selectedStore?.theme.color,
            }}
            className={`text-xl  font-black font-wide ${
              item && !item.availability ? "text-red-500" : ""
            }`}
          >
            {item && !item.availability ? "Unavailable" : ""}
            {item && item.is_offer_available && item.availability
              ? "Show Offer"
              : ""}
          </p>

          <p
            style={{
              backgroundColor: selectedStore?.theme.backgroundColor,
            }}
            className="px-1 text-white rounded-lg text-end "
          >
            £ {displayPrice}
          </p>
        </div>
        <img
          src={item.logo}
          onClick={() => itemHandler(item)}
          alt="store item"
          className="object-contain object-center w-32 h-32 mx-auto mb-4 md:h-40 md:w-40 lg:w-full lg:h-40"
        />
        <div className="flex items-start justify-between gap-2 mt-4 mb-0">
          <h2
            className={`font-bold w-auto  truncate ${
              item.name.length > 20 ? "text-lg" : "lg:text-lg md:text-sm "
            }`}
          >
            {item.name}
          </h2>
          <button
            style={{
              backgroundColor:
                addedItem || isAdded
                  ? "gray"
                  : selectedStore?.theme.backgroundColor,
            }}
            className={`px-4 py-2 font-bold text-white rounded justify-self-end`}
            onClick={() => addToList(item, changeButtonColor, isAdded)}
          >
            <FaPlus />
          </button>
        </div>
      </div>
    </div>
  );
};
const ItemGrid = ({
  selectedStore,
  user,
  items,
  addToList,
  listItems,
  activeList,
}) => {
  return (
    <div className="">
      <div className="z-30 grid items-center grid-cols-1 gap-4 mt-20 md:mx-4 lg:mx-0 justify-items-center sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 4xl:grid-cols-5 4xl:justify-items-start 4xl:items-start 4xl:gap-1 ">
        {items.map((item, index) => (
          <ItemCard
            selectedStore={selectedStore}
            user={user}
            key={index}
            item={item}
            listItems={listItems}
            addToList={addToList}
          />
        ))}
      </div>
    </div>
  );
};
